<div class="upt crm-container">
  <!-- View switch -->
  <div class="upt__switch">
    <button
      class="upt__switch-btn"
      type="button"
      [class.upt__switch-btn--active]="activeView === 'email'"
      (click)="setView('email')"
    >
      <i class="pi pi-user"></i>
      <span>Search by Email</span>
    </button>
    <button
      class="upt__switch-btn"
      type="button"
      [class.upt__switch-btn--active]="activeView === 'contract'"
      (click)="setView('contract')"
    >
      <i class="pi pi-file"></i>
      <span>Search by Contract</span>
    </button>
  </div>

  <!-- ============ FIND A PROFILE (by email) ============ -->
  <div class="upt__view" *ngIf="activeView === 'email'">
    <!-- Search bar -->
    <div class="upt__searchbar">
      <div class="upt__searchbar-field">
        <i class="pi pi-envelope upt__searchbar-icon"></i>
        <input
          id="upt-email"
          class="upt__searchbar-input"
          type="text"
          [(ngModel)]="emailSearch"
          placeholder="Search user profiles by email address..."
          (keyup.enter)="onSearchByEmail()"
        />
      </div>
      <button
        class="upt__searchbar-btn"
        type="button"
        [disabled]="isSearchingUsers"
        (click)="onSearchByEmail()"
      >
        <i class="pi" [ngClass]="isSearchingUsers ? 'pi-spin pi-spinner' : 'pi-search'"></i>
        <span>{{ isSearchingUsers ? 'Searching' : 'Search' }}</span>
      </button>
    </div>

    <!-- Master / detail -->
    <div class="upt__workspace">
      <!-- Results (master) -->
      <aside class="upt__results">
        <header class="upt__results-head">
          <span class="upt__results-title">Results</span>
          <span class="upt__count" *ngIf="searchResultCount">{{ searchResultCount }}</span>
        </header>
        <div class="upt__results-body">
          <div class="upt__overlay" *ngIf="isSearchingUsers">
            <p-progressSpinner styleClass="upt__spinner"></p-progressSpinner>
          </div>
          <div class="upt__scroll" [class.upt__scroll--busy]="isSearchingUsers">
            <div class="upt__empty" *ngIf="searchResults.length === 0 && !isSearchingUsers">
              <i class="pi pi-users upt__empty-ic"></i>
              <p class="upt__empty-title">No profiles yet</p>
              <p class="upt__empty-text">Search by email to get started.</p>
            </div>
            <button
              class="upt__profile-card"
              type="button"
              *ngFor="let user of searchResults; trackBy: trackByUserLoginId"
              [class.upt__profile-card--active]="isUserSelected(user)"
              (click)="onSelectUser(user)"
            >
              <span class="upt__avatar">{{ getUserInitials(user) }}</span>
              <span class="upt__profile-info">
                <span class="upt__profile-name">{{ getUserDisplayName(user) }}</span>
                <span class="upt__profile-email">{{ getUserEmail(user) }}</span>
              </span>
              <i class="pi pi-angle-right upt__profile-chevron"></i>
            </button>
          </div>
        </div>
      </aside>

      <!-- Detail -->
      <section class="upt__detail">
        <!-- Placeholder -->
        <div class="upt__detail-empty" *ngIf="!selectedUser">
          <i class="pi pi-id-card upt__detail-empty-ic"></i>
          <p class="upt__empty-title">Select a profile</p>
          <p class="upt__empty-text">
            Choose a profile from the results to view its linked contracts and history.
          </p>
        </div>

        <ng-container *ngIf="selectedUser">
          <!-- Profile header -->
          <header class="upt__detail-head">
            <span class="upt__avatar upt__avatar--lg">{{ getUserInitials(selectedUser) }}</span>
            <div class="upt__detail-id">
              <h3 class="upt__detail-name">{{ getUserDisplayName(selectedUser) }}</h3>
              <p class="upt__detail-email">
                <i class="pi pi-envelope"></i>{{ getUserEmail(selectedUser) }}
              </p>
            </div>
          </header>

          <!-- Segmented tabs -->
          <div class="upt__tabs">
            <button
              class="upt__tab"
              type="button"
              [class.upt__tab--active]="detailTab === 'contracts'"
              (click)="setDetailTab('contracts')"
            >
              <i class="pi pi-check-circle"></i>
              <span>Linked Contracts</span>
              <span class="upt__tab-count">{{ linkedContracts.length }}</span>
            </button>
            <button
              class="upt__tab"
              type="button"
              [class.upt__tab--active]="detailTab === 'link'"
              (click)="setDetailTab('link')"
            >
              <i class="pi pi-link"></i>
              <span>Link a Contract</span>
            </button>
            <button
              class="upt__tab"
              type="button"
              [class.upt__tab--active]="detailTab === 'history'"
              (click)="setDetailTab('history')"
            >
              <i class="pi pi-history"></i>
              <span>History</span>
              <span class="upt__tab-count" *ngIf="historyItems.length">{{ historyItems.length }}</span>
            </button>
          </div>

          <!-- Linked contracts pane -->
          <div class="upt__pane" *ngIf="detailTab === 'contracts'">
            <div class="upt__pane-body">
              <div class="upt__overlay" *ngIf="isLoadingLinkedContracts">
                <p-progressSpinner styleClass="upt__spinner"></p-progressSpinner>
              </div>
              <div class="upt__scroll" [class.upt__scroll--busy]="isLoadingLinkedContracts">
                <div class="upt__empty" *ngIf="linkedContracts.length === 0 && !isLoadingLinkedContracts">
                  <i class="pi pi-link upt__empty-ic"></i>
                  <p class="upt__empty-title">No linked contracts</p>
                  <p class="upt__empty-text">Use the “Link a Contract” tab to attach a contract to this profile.</p>
                </div>
                <article
                  class="upt__contract-card"
                  *ngFor="let contract of linkedContracts; trackBy: trackByContractNumber"
                >
                  <span class="upt__contract-ic"><i class="pi pi-file"></i></span>
                  <div class="upt__contract-info">
                    <a
                      class="upt__contract-num upt__contract-link"
                      [class.upt__contract-link--loading]="openingContractNumber === contract.contractNumber"
                      tabindex="0"
                      (click)="openContract(contract.contractNumber)"
                      (keyup.enter)="openContract(contract.contractNumber)"
                    >
                      {{ contract.contractNumber }}
                    </a>
                    <span class="upt__contract-date" *ngIf="contract.linkedAt">
                      Linked {{ formatHistoryDate(contract.linkedAt) }}
                    </span>
                  </div>
                  <button
                    class="upt__toggle-btn upt__toggle-btn--unlink"
                    type="button"
                    [class.upt__toggle-btn--busy]="isContractLinkPending(contract.contractNumber)"
                    [disabled]="isLinkActionInProgress"
                    (click)="onUnlinkContract(contract)"
                  >
                    <i
                      class="pi"
                      [ngClass]="isContractLinkPending(contract.contractNumber) ? 'pi-spin pi-spinner' : 'pi-times'"
                    ></i>
                    <span>{{ isContractLinkPending(contract.contractNumber) ? 'Unlinking' : 'Unlink' }}</span>
                  </button>
                </article>
              </div>
            </div>
          </div>

          <!-- Link a contract pane -->
          <div class="upt__pane" *ngIf="detailTab === 'link'">
            <div class="upt__pane-scroll">
              <p class="upt__pane-hint">
                Search for a contract to link it to this profile.
              </p>
              <div class="upt__link-row">
                <div class="upt__searchbar-field upt__searchbar-field--sm">
                  <i class="pi pi-hashtag upt__searchbar-icon"></i>
                  <input
                    class="upt__searchbar-input"
                    type="text"
                    [(ngModel)]="linkContractNumber"
                    (ngModelChange)="onLinkContractNumberChange()"
                    placeholder="Enter a contract number..."
                    (keyup.enter)="onSearchLinkContract()"
                  />
                </div>
                <button
                  class="upt__link-btn"
                  type="button"
                  [disabled]="isSearchingLinkContract || isLinkActionInProgress"
                  (click)="onSearchLinkContract()"
                >
                  <i class="pi" [ngClass]="isSearchingLinkContract ? 'pi-spin pi-spinner' : 'pi-search'"></i>
                  <span>Find</span>
                </button>
              </div>

              <div class="upt__inline-error" *ngIf="linkContractError">
                <i class="pi pi-exclamation-triangle"></i>
                <span>{{ linkContractError }}</span>
              </div>

              <div
                class="upt__match"
                [class.upt__match--linked]="isLinkContractAlreadyLinked && !isSearchedContractInactive"
                [class.upt__match--blocked]="isLinkBlockedByAssociation || isSearchedContractInactive"
                *ngIf="linkContractMatch"
              >
                <div class="upt__match-head">
                  <i
                    class="pi"
                    [ngClass]="
                      isSearchedContractInactive || isLinkBlockedByAssociation
                        ? 'pi-ban upt__match-ic'
                        : 'pi-file upt__match-ic'
                    "
                  ></i>
                  <div class="upt__match-info">
                    <a
                      class="upt__match-num upt__contract-link"
                      [class.upt__contract-link--loading]="openingContractNumber === linkContractMatch"
                      tabindex="0"
                      (click)="openContract(linkContractMatch)"
                      (keyup.enter)="openContract(linkContractMatch)"
                    >
                      {{ linkContractMatch }}
                    </a>
                    <span class="upt__match-label">
                      {{
                        isSearchedContractInactive
                          ? inactiveContractLinkMessage
                          : isLinkBlockedByAssociation
                            ? linkAssociationMessage
                            : isLinkContractAlreadyLinked
                              ? 'Already linked to this profile'
                              : 'Ready to link'
                      }}
                    </span>
                  </div>
                  <button
                    *ngIf="canOfferContractLink"
                    class="upt__toggle-btn upt__toggle-btn--link"
                    type="button"
                    [class.upt__toggle-btn--busy]="isLinkingContract"
                    [disabled]="isLinkingContract || isLinkActionInProgress"
                    (click)="onLinkContractToProfile()"
                  >
                    <i class="pi" [ngClass]="isLinkingContract ? 'pi-spin pi-spinner' : 'pi-link'"></i>
                    <span>{{ isLinkingContract ? 'Linking' : 'Link' }}</span>
                  </button>
                </div>

                <div
                  class="upt__assoc-users"
                  *ngIf="isLinkBlockedByAssociation && !isSearchedContractInactive && linkAssociationUsers.length"
                >
                  <article
                    class="upt__assoc-user"
                    *ngFor="let user of linkAssociationUsers; trackBy: trackByUserLoginId"
                  >
                    <span class="upt__avatar upt__avatar--linked">{{ getUserInitials(user) }}</span>
                    <div class="upt__assoc-user-info">
                      <span class="upt__assoc-user-name">{{ getUserDisplayName(user) }}</span>
                      <span class="upt__assoc-user-email" *ngIf="getUserEmail(user) !== '—'">{{
                        getUserEmail(user)
                      }}</span>
                    </div>
                  </article>
                </div>
              </div>

              <div class="upt__empty" *ngIf="!linkContractMatch && !linkContractError && !isSearchingLinkContract">
                <i class="pi pi-link upt__empty-ic"></i>
                <p class="upt__empty-title">Link a contract</p>
                <p class="upt__empty-text">Enter a contract number above and select Find to continue.</p>
              </div>
            </div>
          </div>

          <!-- History pane -->
          <div class="upt__pane" *ngIf="detailTab === 'history'">
            <div class="upt__pane-body">
              <div class="upt__overlay" *ngIf="isLoadingHistory">
                <p-progressSpinner styleClass="upt__spinner"></p-progressSpinner>
              </div>
              <div class="upt__scroll" [class.upt__scroll--busy]="isLoadingHistory">
                <div class="upt__empty" *ngIf="historyItems.length === 0 && !isLoadingHistory">
                  <i class="pi pi-history upt__empty-ic"></i>
                  <p class="upt__empty-title">No history</p>
                  <p class="upt__empty-text">Link or unlink activity for this profile will appear here.</p>
                </div>
                <ng-container *ngIf="historyItems.length > 0">
                  <ng-container
                    *ngTemplateOutlet="historyGrid; context: { items: historyItems }"
                  ></ng-container>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </section>
    </div>
  </div>

  <!-- ============ PROFILES ON A CONTRACT ============ -->
  <div class="upt__view" *ngIf="activeView === 'contract'">
    <div class="upt__searchbar">
      <div class="upt__searchbar-field">
        <i class="pi pi-hashtag upt__searchbar-icon"></i>
        <input
          id="upt-contract"
          class="upt__searchbar-input"
          type="text"
          [(ngModel)]="contractSearch"
          placeholder="Search a contract number to see connected profiles..."
          (keyup.enter)="onSearchByContract()"
        />
      </div>
      <button
        class="upt__searchbar-btn"
        type="button"
        [disabled]="isSearchingContractUsers"
        (click)="onSearchByContract()"
      >
        <i class="pi" [ngClass]="isSearchingContractUsers ? 'pi-spin pi-spinner' : 'pi-search'"></i>
        <span>{{ isSearchingContractUsers ? 'Searching' : 'Search' }}</span>
      </button>
    </div>

    <section class="upt__contract-panel">
      <header class="upt__results-head">
        <span class="upt__results-title">
          Linked Profile
          <a
            class="upt__contract-ref upt__contract-ref--link"
            [class.upt__contract-link--loading]="openingContractNumber === activeContractNumber"
            *ngIf="activeContractNumber"
            tabindex="0"
            (click)="openContract(activeContractNumber)"
            (keyup.enter)="openContract(activeContractNumber)"
          >
            #{{ activeContractNumber }}
          </a>
        </span>
        <span class="upt__count" *ngIf="linkedContractProfiles.length">{{ linkedContractProfiles.length }}</span>
      </header>

      <div class="upt__pane-body upt__pane-body--contract">
        <div class="upt__overlay" *ngIf="isSearchingContractUsers">
          <p-progressSpinner styleClass="upt__spinner"></p-progressSpinner>
        </div>
        <div class="upt__scroll" [class.upt__scroll--busy]="isSearchingContractUsers">
          <div
            class="upt__empty"
            *ngIf="!isSearchingContractUsers && linkedContractProfiles.length === 0"
          >
            <i class="pi pi-users upt__empty-ic"></i>
            <p class="upt__empty-title">{{ activeContractNumber ? 'No linked profiles' : 'No profiles loaded' }}</p>
            <p class="upt__empty-text">
              {{
                activeContractNumber
                  ? 'No portal profiles are currently linked to this contract.'
                  : 'Search a contract number to see its linked profiles.'
              }}
            </p>
          </div>
          <article
            class="upt__profile-card upt__profile-card--static"
            *ngFor="let user of linkedContractProfiles; trackBy: trackByUserLoginId"
          >
            <span class="upt__avatar upt__avatar--linked">
              {{ getUserInitials(user) }}
            </span>
            <div class="upt__profile-info">
              <span class="upt__profile-name">{{ getUserDisplayName(user) }}</span>
              <span class="upt__profile-email">{{ getUserEmail(user) }}</span>
            </div>
            <div class="upt__user-actions">
              <button
                class="upt__icon-btn"
                type="button"
                title="View link history"
                aria-label="View link history"
                (click)="onShowHistory(user)"
              >
                <i class="pi pi-history"></i>
              </button>
              <button
                class="upt__toggle-btn"
                type="button"
                [class.upt__toggle-btn--link]="!isUserLinked(user)"
                [class.upt__toggle-btn--unlink]="isUserLinked(user)"
                [class.upt__toggle-btn--busy]="isUserLinkPending(user)"
                [disabled]="isLinkActionInProgress"
                (click)="onToggleContractUserLink(user)"
              >
                <i
                  class="pi"
                  [ngClass]="
                    isUserLinkPending(user)
                      ? 'pi-spin pi-spinner'
                      : isUserLinked(user)
                        ? 'pi-times'
                        : 'pi-link'
                  "
                ></i>
                <span>{{
                  isUserLinkPending(user)
                    ? isUserLinked(user)
                      ? 'Unlinking'
                      : 'Linking'
                    : isUserLinked(user)
                      ? 'Unlink'
                      : 'Link'
                }}</span>
              </button>
            </div>
          </article>
        </div>
      </div>
    </section>
  </div>
</div>

<!-- Link history dialog (contract view) -->
<p-dialog
  [header]="'Profile Link History'"
  [(visible)]="displayHistory"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '640px' }"
  styleClass="upt__dialog upt__dialog--history"
  (onHide)="onCloseHistory()"
>
  <div class="upt__dialog-body">
    <div class="upt__loading" *ngIf="isLoadingDialogHistory">
      <p-progressSpinner styleClass="upt__spinner"></p-progressSpinner>
    </div>

    <div class="upt__empty" *ngIf="!isLoadingDialogHistory && dialogHistoryItems.length === 0">
      <i class="pi pi-history upt__empty-ic"></i>
      <p class="upt__empty-title">No history</p>
    </div>

    <ng-container *ngIf="!isLoadingDialogHistory && dialogHistoryItems.length > 0">
      <ng-container
        *ngTemplateOutlet="historyGrid; context: { items: dialogHistoryItems }"
      ></ng-container>
    </ng-container>
  </div>

  <ng-template pTemplate="footer">
    <button class="crm-button upt__dialog-close" type="button" (click)="onCloseHistory()">Close</button>
  </ng-template>
</p-dialog>

<ng-template #historyGrid let-items="items">
  <p-table
    class="upt__grid"
    styleClass="p-datatable-gridlines upt__grid-table"
    [value]="items"
    [rows]="20"
    [paginator]="items.length > 20"
    [rowHover]="true"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="upt__grid-col--status">Status</th>
        <th class="upt__grid-col--contract">Contract Number</th>
        <th class="upt__grid-col--date">Date of Update</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
      <tr>
        <td>
          <span
            class="upt__tag"
            [class.upt__tag--linked]="item.link"
            [class.upt__tag--unlinked]="!item.link"
          >
            {{ getHistoryActionLabel(item.link) }}
          </span>
        </td>
        <td>
          <a
            class="upt__event-num upt__contract-link"
            [class.upt__contract-link--loading]="openingContractNumber === item.contractNumber"
            tabindex="0"
            (click)="openContract(item.contractNumber)"
            (keyup.enter)="openContract(item.contractNumber)"
          >
            {{ item.contractNumber }}
          </a>
        </td>
        <td>
          <span class="upt__event-date">{{ formatHistoryDate(item.createdAt) }}</span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>

<p-toast></p-toast>
